import axios from 'axios'
import {
  CREATE_BADGE_SUCCESS,
  CREATE_BADGE_ERROR,
  GET_BADGE_SUCCESS,
  GET_BADGE_ERROR,
  ISSUE_BADGE_SUCCESS,
  ISSUE_BADGE_ERROR,
} from './constants'
import store from '../store'

export const createBadge = (formObj, setFormObj) => async (dispatch) => {
  setFormObj((data) => ({
    ...data,
    state: 'submitting',
  }))
  const token = store.getState().auth.token
  const { title, issuedBy, version, authorizedBy, type, level, time, expirationYears, criteria, description, image } =
    formObj
  let { skills } = formObj
  const titleString = `title=${title}&`
  const issuedByString = `issuedBy=${issuedBy}&`
  const versionString = `version=${version}&`
  const authorizedByString = `authorizedBy=${authorizedBy}&`
  const levelString = `levelType=${level.toLowerCase()}&`
  const typeString = `courseType=${type.toLowerCase()}&`
  const descriptionString = `description=${encodeURIComponent(description.value)}&`
  const expirationYearsString =
    expirationYears !== 0 ? `expirationYears=${expirationYears}&` : `expirationYears=${'never'}&`
  const criteriaString = `criteria=${criteria}&`
  const timeString = `time=${encodeURIComponent(time)}&`
  skills = skills.value.split(',')
  skills = skills.map(encodeURIComponent)
  const skillsString = 'skills[]=' + skills.join('&skills[]=')

  let formData = new FormData()
  console.log(image);
  formData.append('badge', image[0])

  try {
    let res = await fetch(
      `${process.env.REACT_APP_API_URI}/xcb/api/badge/create?${
        titleString +
        issuedByString +
        versionString +
        authorizedByString +
        levelString +
        typeString +
        descriptionString +
        expirationYearsString +
        criteriaString +
        timeString +
        skillsString
      }`,
      {
        method: 'POST',
        headers: {
          'x-auth-token': token,
        },
        body: formData,
      }
    )
    if (!res.ok) {
      const error = await res.text()
      throw Error(error)
    } else {
      let data = await res.json()
      dispatch({ type: CREATE_BADGE_SUCCESS, payload: data.content })
    }
  } catch (err) {
    const errResp = JSON.parse(err.message)

    if (!errResp) {
      dispatch({
        type: CREATE_BADGE_ERROR,
        payload: [{ msg: 'Please try again' }],
      })
    } else dispatch({ type: CREATE_BADGE_ERROR, payload: errResp.errors })
  } finally {
    setFormObj((data) => ({
      ...data,
      state: 'idle',
      title: '',
      version: '',
      issuedBy: '',
      authorizedBy: '',
      description: { counter: 0, value: '', status: '', maxCount: 500 },
      skills: { counter: 0, value: '', status: '', maxCount: 250 },
      type: 'Select type of the badge',
      level: 'Select level of the badge',
      time: '',
      expirationYears: '',
      criteria: '',
      image: [],
    }))
  }
}

export const getBadges = (formObj, setFormObj) => async (dispatch) => {
  setFormObj((data) => ({
    ...data,
    state: 'submitting',
  }))
  const token = store.getState().auth.token
  const config = {
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
  }
  try {
    let res = await axios.get(`${process.env.REACT_APP_API_URI}/xcb/api/badge`, config)
    dispatch({
      type: GET_BADGE_SUCCESS,
      payload: res['data']['content'],
    })
  } catch (err) {
    const errResp = err.response
    if (!errResp) {
      dispatch({
        type: GET_BADGE_ERROR,
        payload: [{ msg: 'Please try again' }],
      })
    } else dispatch({ type: GET_BADGE_ERROR, payload: errResp.data.errors })
  } finally {
    setFormObj((data) => ({
      ...data,
      state: 'idle',
    }))
  }
}

export const issueBadge = (formObj, setFormObj) => async (dispatch) => {
  setFormObj((data) => ({
    ...data,
    state: 'submitting',
  }))
  const token = store.getState().auth.token
  const { userEmail, selectedBadge } = formObj
  const config = {
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
  }
  const badgeArray = selectedBadge.split('-');
  const badgeTitle = badgeArray.slice(0,badgeArray.length-1).join('-').trim()
  const version = badgeArray[badgeArray.length-1].trim()

  const body = JSON.stringify({ userEmail: userEmail.value, badgeTitle, version })

  try {
    let res = await axios.post(`${process.env.REACT_APP_API_URI}/xcb/api/badge/issue`, body, config)
    const { content } = res.data
    dispatch({
      type: ISSUE_BADGE_SUCCESS,
      payload: content,
    })
  } catch (err) {
    const errResp = err.response
    if (!errResp) {
      dispatch({
        type: ISSUE_BADGE_ERROR,
        payload: [{ msg: 'Please try again' }],
      })
    } else dispatch({ type: ISSUE_BADGE_ERROR, payload: errResp.data.errors })
  } finally {
    setFormObj((data) => ({
      ...data,
      state: 'idle',
      userEmail: { status: '', value: '' },
      selectedBadge: 'Select the badge',
    }))
  }
}
